import { render, staticRenderFns } from "./CourseModule.vue?vue&type=template&id=54f75851&scoped=true"
import script from "./CourseModule.vue?vue&type=script&lang=js"
export * from "./CourseModule.vue?vue&type=script&lang=js"
import style0 from "./CourseModule.vue?vue&type=style&index=0&id=54f75851&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f75851",
  null
  
)

export default component.exports